
import { css } from 'lit';
export default css`
/* Apply standardized box sizing to the component. */
:host {
  box-sizing: border-box;
  font-family: var(--ff-display);
}
:host *,
:host *::before,
:host *::after {
  box-sizing: inherit;
}
/* unset browser defaults for headings and p */
:host:is(h1,h2,h3,h4,h5,h6,p),
h1,h2,h3,h4,h5,h6 {
  all: unset;
}
/* Image reset */
img {
  max-width: 100%;
}
/* Apply proper CSS for accessibly hiding elements to each component. */
.sr-only,
.visually-hidden {
  position: absolute !important;
  overflow: hidden;
  clip: rect(1px, 1px, 1px, 1px);
  width: 1px;
  height: 1px;
  word-wrap: normal;
}
/* Apply component specific CSS */
.dropdown-list-panel{
  display:flex;
  flex-direction:column;
  outline:1px solid var(--color-neutral-dark);
}

  @media (min-width: 1024px){.dropdown-list-panel{
    max-width:500px
}
  }

[hidden]{
  display:none !important;
}

.dropdown-list-overlay:after{
  content:'';
  position:fixed;
  top:0;
  left:0;
  width:100%;
  height:100%;
  z-index:0;
}

.dropdown-list-button{
  border:0;
  position:sticky;
  cursor:pointer;
  display:flex;
  width:100%;
  align-items:center;
  justify-content:space-between;
  color:var(--color-neutral-dark);
  background-color:var(--color-neutral-white);
  margin:0;
  padding:var(--spacing-04);
  font-size:var(--body-01-font-size);
}

.dropdown-list-button.active{
    background-color:var(--color-neutral-lightest);
  }

.dropdown-list-button:focus-visible{
    outline:2px solid var(--color-system-info-darkest);
  }

.dropdown-list-button[aria-disabled='true']{
  cursor:not-allowed;
  pointer-events:none;
  background-color:var(--color-neutral-lightest);
}

.dropdown-list-icon{
  color:var(--color-system-info-darkest);
  display:flex;
  align-items:center;
  width:18px;
  height:22px;
}

@media (prefers-reduced-motion: no-preference){

.dropdown-list-icon{
    transition:all var(--duration-slowly) ease-in-out
}
  }

.dropdown-list-label{
  display:block;
  padding-bottom:var(--spacing-04);
  text-align:left;
  font-family:var(--ff-body);
  font-size:var(--body-01-font-size);
  line-height:var(--body-02-line-height);
  font-weight:var(--fw-normal);
}

.dropdown-list-content{
  position:relative;
  z-index:5;
}

.dropdown-list-menu{
  max-height:var(--spacing-64);
  overflow-y:auto;
  position:absolute;
  left:0;
  right:0;
  outline:1px solid var(--color-neutral-dark);
  background-color:var(--color-neutral-white);
}

.hidden{
  display:none;
}
`;